<table [class]="cssClass()">
  @for (item of summaryItems(); track item.label) {
    <tr>
      <td class="text-nowrap align-top pe-3" [class.label-min-width]="labelMinWidth()">
        <strong>{{ item.label }}</strong>
      </td>
      <td>
        <div
          [innerHTML]="item.value"
          [class]="item.cssClass"
          [class.text-end]="item.textRight"
          [class.text-nowrap]="item.noWrap"
        ></div>
      </td>
    </tr>
  }
</table>
